import { useNoteTemplates } from '@/hooks/use-api'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Label } from '@/components/ui/label'
import type { NoteTemplate } from '@/types/noteSession'

interface TemplateSelectorProps {
  value?: string
  onSelect: (template: NoteTemplate | null) => void
  disabled?: boolean
}

export function TemplateSelector({ value, onSelect, disabled }: TemplateSelectorProps) {
  const { data: templates, isLoading } = useNoteTemplates()

  const handleValueChange = (templateId: string) => {
    if (templateId === 'none') {
      onSelect(null)
      return
    }

    const template = templates?.find((t) => t.id === templateId)
    if (template) {
      onSelect(template)
    }
  }

  return (
    <div className="space-y-2">
      <Label htmlFor="template-selector">Template</Label>
      <Select
        value={value || 'none'}
        onValueChange={handleValueChange}
        disabled={disabled || isLoading}
      >
        <SelectTrigger id="template-selector" aria-label="Select note template">
          <SelectValue placeholder="Choose a template..." />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="none">No template</SelectItem>
          {templates?.map((template) => (
            <SelectItem key={template.id} value={template.id}>
              {template.name} {template.is_system && '(System)'}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
